import React, { FunctionComponent, ReactElement } from 'react';

import { Popover2Props } from '@yandex-360/orb-components/dist/components/Popover2/types';
import cn from 'classnames';

import { Popover } from '../popover';
import classes from './style.css';

type MoreButtonPopoverProps = Popover2Props & {
    className?: string;
    items: Array<ReactElement | undefined | null>;
    onClose: () => void;
};

const MoreButtonPopover: FunctionComponent<MoreButtonPopoverProps> = ({
    placement,
    className,
    isOpen,
    triggerRef,
    scope,
    offset = 8,
    onClose,
    items,
}) => {
    return (
        <Popover
            preventInteractOutside={false}
            placement={placement}
            offset={offset}
            isOpen={isOpen}
            triggerRef={triggerRef}
            scope={scope}
            onOpenChange={onClose}
            onClick={onClose}
            data-test-id="more-button-popover"
            className={cn(classes.Container, className)}
        >
            {items}
        </Popover>
    );
};

export default MoreButtonPopover;
